import {
  SharedserviceMelcoModelsDesignListItem,
  selectThumbnailForSize,
} from "melco-shared-logic";

export const useDesignThumbnailURL = (
  design: SharedserviceMelcoModelsDesignListItem,
  width: number,
  height: number
) => {
  const thumbnail = selectThumbnailForSize(
    design.previews ?? [],
    Math.max(width, height)
  );

  return thumbnail?.url;
};
